// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import AxiosPlugin from './libs/AxiosPlugin'
import Request from './utils/request'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import store from './store/'
import './assets/iconfont/font.css'
import { isLoggedIn } from '@/utils/storage';

Vue.use(Request)
Vue.use(AxiosPlugin)
Vue.use(ElementUI);
Vue.config.productionTip = false;


router.beforeEach(async (to, from, next) => {
  try {
    // 从 store 中获取网站标题
    const companyInfo = await store.dispatch('company/fetchCompanyInfo')
    const siteTitle = companyInfo.title || '报名系统'
    
    // 设置页面标题
    if (to.meta && to.meta.title) {
      document.title = `${to.meta.title} - ${siteTitle}`
    } else {
      document.title = siteTitle
    }
    
    const stationId = to.params.stationId
    if (to.path.includes('/user-center') && !isLoggedIn()) {
      next(`/${stationId}/login`)
    } else {
      next()
    }
  } catch (error) {
    next()
  }
})

/* eslint-disable no-new */
const messages = {
  'en-US': {
    header: {
      title: 'FormMaking',
      document: 'Docs',
      pricing: 'Pricing',
      advanced: 'Advanced',
    }
  },
  'zh-CN': {
    header: {
      title: '表单设计器',
      document: '使用文档',
      pricing: '商业授权',
      advanced: '高级版本',
    }
  }
}

const i18n = new VueI18n({
  messages: {
    'en-US': {
      ...enLocale, ...messages['en-US']
    },
    'zh-CN': {
      ...zhLocale, ...messages['zh-CN']
    }
  }
})

Vue.use(ElementUI, { 
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
import FormMaking from 'form-making'
import 'form-making/dist/FormMaking.css'
Vue.use(FormMaking, {
  i18n
})
new Vue({
  i18n,
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js